import { render } from "./date-format-date.vue?vue&type=template&id=64c22db2"
import script from "./date-format-date.vue?vue&type=script&lang=js"
export * from "./date-format-date.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__